import { Component } from '@angular/core';

@Component({
	selector: 'app-navigation-mobile-component',
	template: `<div id="main-menu">
		<div class="logoDiv">
			<a href="/"><img class="logo svg navbar-header-logo" src="/assets/images/whitelogo.svg" alt="devere-logo" width="70px" height="20px" /></a>
		</div>
		<div class="toggleDiv">
			<div id="toggle">
				<ul>
					<li>
						<a aria-label="deVere Group" href="https://www.devere-group.com/#elementor-action%3Aaction%3Dpopup%3Aopen%26settings%3DeyJpZCI6Ijg0IiwidG9nZ2xlIjp0cnVlfQ%3D%3D">
							<span class="line l1"></span>
							<span class="line l2"></span>
							<span class="line l3"></span>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div> `,
	styleUrls: ['./navigationmobile.component.scss']
})
export class NavigationMobileComponent {}
